import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../layout/index'
import individualLayout from '../layout/individual'
import CompanyLayout from '../layout/company'
// import { getToken } from '@/utils/auth'
// import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'home',
        meta: { name: '首页' },
        component: () => import(/* webpackChunkName: "home" */ '../views/home.vue')
      },
      {
        path: 'portal/news/list',
        meta: { name: '新闻列表' },
        component: () => import(/* webpackChunkName: "news-list" */ '../views/portal/news/list.vue')
      },
      {
        path: 'portal/news/detail',
        meta: { name: '新闻详情' },
        component: () => import(/* webpackChunkName: "news-detail" */ '../views/portal/news/detail.vue')
      },
      {
        path: 'portal/job/list',
        meta: { name: '岗位列表' },
        component: () => import(/* webpackChunkName: "job-list" */ '../views/portal/job/list.vue')
      },
      {
        path: 'portal/job/detail',
        meta: { name: '岗位详情' },
        component: () => import(/* webpackChunkName: "job-detail" */ '../views/portal/job/detail.vue')
      },
      {
        path: 'portal/information/list',
        meta: { name: '资讯列表' },
        component: () => import(/* webpackChunkName: "information-list" */ '../views/portal/information/list.vue')
      },
      {
        path: 'portal/information/detail',
        meta: { name: '资讯详情' },
        component: () => import(/* webpackChunkName: "information-detail" */ '../views/portal/information/detail.vue')
      },
      {
        path: 'portal/business',
        meta: { name: '创业' },
        component: () => import(/* webpackChunkName: "recruit" */ '../views/portal/business')
      },
      {
        path: 'portal/business/businessTypeList',
        meta: { name: '创业列表' },
        component: () => import(/* webpackChunkName: "information-list" */ '../views/portal/business/businessTypeList.vue')
      },
      {
        path: 'portal/business/businessDetail',
        meta: { name: '创业详情' },
        component: () => import(/* webpackChunkName: "information-detail" */ '../views/portal/business/businessDetail.vue')
      },
      {
        path: 'portal/recruit',
        meta: { name: '招人才' },
        component: () => import(/* webpackChunkName: "recruit" */ '../views/portal/recruit')
      },
      {
        path: 'portal/recruit/detail',
        meta: { name: '人才详情' },
        component: () => import(/* webpackChunkName: "recruit-detail" */ '../views/portal/recruit/detail.vue')
      },
      {
        path: 'portal/lounge',
        meta: { name: '两岸人才会客厅' },
        component: () => import(/* webpackChunkName: "lounge" */ '../views/portal/lounge')
      },
      {
        path: 'portal/lounge/list',
        meta: { name: '会客厅列表' },
        component: () => import(/* webpackChunkName: "lounge-list" */ '../views/portal/lounge/list.vue')
      },
      {
        path: 'portal/lounge/detail',
        meta: { name: '会客厅详情' },
        component: () => import(/* webpackChunkName: "lounge-detail" */ '../views/portal/lounge/detail.vue')
      },
      {
        path: 'portal/contactUs',
        meta: { name: '联系我们' },
        component: () => import(/* webpackChunkName: "contactUs" */ '../views/portal/contactUs')
      },
      {
        path: '/company/companyHomePage',
        meta: { name: '公司主页' },
        component: () => import(/* webpackChunkName: "companyHomePage" */ '../views/company/companyHomePage.vue')
      }
    ]
  },
  // 个人中心路由
  {
    path: '/',
    component: individualLayout,
    children: [
      {
        path: 'individual/individualInfo',
        meta: { name: '个人信息' },
        component: () => import(/* webpackChunkName: "base-info" */ '../views/individual/individualInfo.vue')
      },
      {
        path: 'individual/myResume',
        meta: { name: '我的简历' },
        component: () => import(/* webpackChunkName: "base-info" */ '../views/individual/myResume.vue')
      },
      {
        path: 'individual/deliveryRecord',
        meta: { name: '投递记录' },
        component: () => import(/* webpackChunkName: "base-info" */ '../views/individual/deliveryRecord.vue')
      },
      {
        path: 'individual/myFavorite',
        meta: { name: '我的收藏' },
        component: () => import(/* webpackChunkName: "base-info" */ '../views/individual/myFavorite.vue')
      },
      {
        path: 'individual/whoSeenMe',
        meta: { name: '谁看过我' },
        component: () => import(/* webpackChunkName: "base-info" */ '../views/individual/whoSeenMe.vue')
      }
    ]
  },
  // 企业中心路由
  {
    path: '/',
    component: CompanyLayout,
    children: [
      {
        path: 'company/baseInfo',
        meta: { name: '基本资料' },
        component: () => import(/* webpackChunkName: "base-info" */ '../views/company/baseInfo.vue')
      },
      {
        path: 'company/identification',
        meta: { name: '企业认证' },
        component: () => import(/* webpackChunkName: "base-info" */ '../views/company/identification.vue')
      },
      {
        path: 'company/mien',
        meta: { name: '企业风采' },
        component: () => import(/* webpackChunkName: "base-info" */ '../views/company/mien.vue')
      },
      {
        path: 'company/postManage',
        meta: { name: '岗位管理' },
        component: () => import(/* webpackChunkName: "post-manage" */ '../views/company/postManage.vue')
      },
      {
        path: 'company/postPublish',
        meta: { name: '岗位发布' },
        component: () => import(/* webpackChunkName: "post-publish" */ '../views/company/postPublish.vue')
      },
      {
        path: 'company/resumeManage',
        meta: { name: '求职简历' },
        component: () => import(/* webpackChunkName: "resume-manage" */ '../views/company/resumeManage.vue')
      },
      {
        path: 'company/interviewManage',
        meta: { name: '面试管理' },
        component: () => import(/* webpackChunkName: "interview-manage" */ '../views/company/interviewManage.vue')
      },
      {
        path: 'company/talentLibrary',
        meta: { name: '人才库' },
        component: () => import(/* webpackChunkName: "talent-library" */ '../views/company/talentLibrary.vue')
      },
      {
        path: 'company/resumeDetail',
        meta: { name: '简历详情' },
        component: () => import(/* webpackChunkName: "resume-detail" */ '../views/company/resumeDetail.vue')
      },
      {
        path: 'company/talentResumeDetail',
        meta: { name: '人才库-简历详情' },
        component: () => import(/* webpackChunkName: "talent-resume-detail" */ '../views/company/talentResumeDetail.vue')
      }
    ]
  },

  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '/map',
        name: 'map',
        meta: { name: '人才地图' },
        component: () => import(/* webpackChunkName: "login" */ '../views/portal/map/index.vue')
      }
    ]
  },
  {
    path: '/company/resumePrint',
    meta: { name: '简历打印' },
    component: () => import(/* webpackChunkName: "resume-print" */ '../views/company/resumePrint.vue')
  },
  {
    path: '/portal/recruit/recruitResumePrint',
    meta: { name: '人才简历打印' },
    component: () => import(/* webpackChunkName: "resume-print" */ '../views/portal/recruit/recruitResumePrint.vue')
  },
  {
    path: '/noPermission',
    meta: { name: '无权限访问' },
    component: () => import(/* webpackChunkName: "noPermission" */ '../views/noPermission.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { name: '用户登录' },
    component: () => import(/* webpackChunkName: "login" */ '../views/login.vue')
  },
  {
    path: '/register',
    meta: { name: '用户注册' },
    component: () => import(/* webpackChunkName: "register" */ '../views/register.vue')
  },
  {
    path: '/404',
    meta: { name: '页面不存在' },
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    const toPositionPathArr = ['/home', '/portal/recruit', '/portal/job/list']
    const fromPositionPathArr = [
      '/home',
      '/portal/recruit',
      '/portal/job/list',
      '/portal/lounge /home',
      '/portal/information/list /portal/lounge',
      '/portal/contactUs /portal/information/list'
    ]
    if (!fromPositionPathArr.includes(from.fullPath) && toPositionPathArr.includes(to.fullPath)) {
      return
    }
    // 页面跳转的时候，新页面始终是在顶部
    return {
      x: 0,
      y: 0
    }
  }
})

// router.beforeEach((to, from, next) => {
//   if (to.meta.authorization) { // 访问页面需要登录态
//     if (!(getToken() && store.getters.userType)) {
//       window.sessionStorage.setItem('urlAfterLogin', window.location.href)
//       window.location.href = `${process.env.VUE_APP_LOGIN_URL}?returnUrl=${process.env.VUE_APP_ROOT_URL}/home`
//       next(false)
//     } else if (to.meta.role && !to.meta.role.includes(store.getters.userType)) { // 角色限制存在，且当前登录用户的角色不在限制范围内
//       next('/noPermission')
//     } else {
//       next()
//     }
//   } else {
//     next()
//   }
// })

router.afterEach((to, from) => {
  document.title = `${to.meta.name}-厦门市思明区台湾人才服务中心`
})
export default router
